import React from "react";
import { Box } from "@rebass/grid";

import { ExperimentPhase, ExperimentPhaseType, Icon } from "api/models";
import { ElementsProps } from "../constants/elementsProps";

import { ApplicationImageAssets } from "../components/ApplicationImageAssets";
import { HiddenFlex } from "../components/uiElement";

interface Props extends ElementsProps {
  applicationId: string;
  currentPhase?: ExperimentPhase | null;
  assets: Icon[];
  history: any;
  trafficIndicator?: string;
}

function ApplicationElementsPage({
  applicationId,
  history,
  currentPhase = null,
  assets,
  onControl,
  onRemove,
  onDeactivate,
  onSetTop,
  trafficIndicator,
  currentIteration,
}: Props) {
  return (
    <HiddenFlex flexDirection="column">
      <Box>
        <ApplicationImageAssets
          applicationId={applicationId}
          title="Icons"
          assets={assets}
          onControl={onControl}
          onRemove={onRemove}
          onDeactivate={onDeactivate}
          onSetTop={onSetTop}
          phaseType={ExperimentPhaseType.icon}
          currentPhase={currentPhase}
          history={history}
          trafficIndicator={trafficIndicator}
          currentIteration={currentIteration}
        />
      </Box>
    </HiddenFlex>
  );
}

export default ApplicationElementsPage;
